import React from "react";
import { ADD_NEW, NO_RECORD, SEPERATOR } from "../Constants";
function userTimer({ before, after }) {
    let timer;
    return function () {
        if (timer)
            clearTimeout(timer);
        // console.log("firing before");
        before();
        timer = setTimeout(() => {
            // console.log("firing after");
            after();
        }, 1000);
    };
}
export const useListItemHighlighter = (flatDataSource, onSelectedIdnexChanged) => {
    const highlightedIndexRef = React.useRef(-1);
    const hightlightSourceRef = React.useRef(undefined);
    const isHighlightSuspendedRef = React.useRef(false);
    const subscribers = React.useRef(new Set());
    const suspendMouseHighlight = userTimer({
        before: () => isHighlightSuspendedRef.current = true,
        after: () => isHighlightSuspendedRef.current = false
    });
    const subscribe = (callback) => {
        subscribers.current.add(callback);
        return () => subscribers.current.delete(callback);
    };
    const publish = React.useCallback(() => {
        subscribers.current.forEach(s => s());
    }, []);
    const getHighlightSource = React.useCallback(() => {
        return hightlightSourceRef.current;
    }, []);
    const getHighlightedindex = React.useCallback(() => {
        return highlightedIndexRef.current;
    }, []);
    const isIndexHighlighted = React.useCallback((index) => {
        return highlightedIndexRef.current === index;
    }, []);
    const setHighlightedIndexByKeyboard = React.useCallback((index) => {
        if (index === highlightedIndexRef.current)
            return;
        highlightedIndexRef.current = index;
        hightlightSourceRef.current = "k";
        publish();
    }, [publish]);
    const setHighlightedIndexByMouse = React.useCallback((index) => {
        if (isHighlightSuspendedRef.current)
            return;
        if (index === highlightedIndexRef.current)
            return;
        highlightedIndexRef.current = index;
        hightlightSourceRef.current = "m";
        publish();
    }, [publish]);
    const getNextIndex = (index) => {
        if (index === flatDataSource.length - 1)
            return index;
        const item = flatDataSource[index + 1];
        if (item === SEPERATOR || item === ADD_NEW || item === NO_RECORD)
            return getNextIndex(index + 1);
        return index + 1;
    };
    const getPrevIndex = (index) => {
        if (index === 0) {
            const item2 = flatDataSource[index];
            if (item2 === SEPERATOR || item2 === ADD_NEW || item2 === NO_RECORD)
                return getNextIndex(0);
            return 0;
        }
        const item = flatDataSource[index - 1];
        if (item === SEPERATOR || item === ADD_NEW || item === NO_RECORD)
            return getPrevIndex(index - 1);
        return index - 1;
    };
    const handleKeydown = (e) => {
        if (e.key === "ArrowDown") {
            suspendMouseHighlight();
            setHighlightedIndexByKeyboard(getNextIndex(getHighlightedindex()));
            return true;
        }
        else if (e.key === "ArrowUp") {
            suspendMouseHighlight();
            setHighlightedIndexByKeyboard(getPrevIndex(getHighlightedindex()));
            return true;
        }
        else if (e.key === "Enter") {
            onSelectedIdnexChanged(getHighlightedindex());
            // setHighlightedIndexByKeyboard(-1);
            // setSelectedIndex(getHighlightedindex());
            return true;
        }
        else if (e.key === "Tab") {
            onSelectedIdnexChanged(getHighlightedindex());
            // setHighlightedIndexByKeyboard(-1);
            // setSelectedIndex(getHighlightedindex());
            return true;
        }
        else {
            return false;
        }
    };
    return {
        setHighlightedIndexByKeyboard, getHighlightedindex,
        subscribe, isIndexHighlighted, setHighlightedIndexByMouse, getHighlightSource, handleKeydown
    };
};
